import { motion } from "framer-motion";
import CinematicHero from "../components/site/CinematicHero";
import ManifestoChapters from "../components/site/ManifestoChapters";
import PortfolioGrid from "../components/site/PortfolioGrid";
import EditorialMarquee from "../components/site/EditorialMarquee";
import SimplyGold from "../components/site/SimplyGold";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <main data-testid="page-home">
      <CinematicHero />

      {/* Intro band */}
      <section className="relative bg-[var(--bg)] py-20 md:py-28 border-t border-white/5" data-testid="intro-band">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-end">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9 }}
            className="md:col-span-4"
          >
            <div className="h-eyebrow mb-4">§ Introduction</div>
            <div className="numeral text-6xl md:text-8xl leading-none">00</div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="md:col-span-8"
          >
            <h2 className="h-display text-4xl md:text-6xl leading-[0.98]">
              A cinematic studio for people who <span className="italic font-serif-editorial text-[var(--gold)] font-light">refuse to micromanage</span> their storyteller.
            </h2>
            <p className="mt-10 font-serif-editorial text-lg md:text-xl leading-relaxed text-[var(--ink)]/80 max-w-2xl">
              Sebastian Visual Corp is a small, disciplined operation building weddings, corporate cinema, editorial portraiture and regulation-friendly aerial work. We show up early, we work quietly, and we deliver a body of work that stands on its own.
            </p>
          </motion.div>
        </div>
      </section>

      <EditorialMarquee />

      <PortfolioGrid />

      <ManifestoChapters />

      <SimplyGold />

      {/* Closing CTA band */}
      <section className="relative bg-[var(--bg)] py-20 md:py-28 border-t border-white/5" data-testid="closing-cta">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 1 }}
          >
            <div className="h-eyebrow mb-8">§ Next</div>
            <h2 className="h-display text-5xl md:text-7xl lg:text-8xl leading-[0.9]">
              Discuss<br/>
              <span className="italic font-serif-editorial text-[var(--gold)] font-light">your vision.</span>
            </h2>
            <p className="mt-10 font-serif-editorial text-lg md:text-xl text-[var(--ink)]/80 max-w-xl mx-auto">
              Private consultations by appointment. We accept a limited number of commissions each quarter.
            </p>
            <Link
              to="/contact"
              data-testid="closing-cta-button"
              className="inline-flex items-center gap-3 mt-12 bg-[var(--royal)] hover:bg-[var(--royal-soft)] text-white px-10 py-5 font-sans-display uppercase tracking-[0.3em] text-[11px] transition-colors"
            >
              Request a Private Consultation →
            </Link>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
